|<template>
	<div id="adminLTE" class="wrapper" v-if="1==1">
		<vue-snotify></vue-snotify>
		<nav class="main-header navbar navbar-expand-md navbar-light navbar-white bg-aces">
			<div :class="container">
				<router-link to="/" class="navbar-brand">
					<img src="../node_modules/admin-lte/dist/img/AdminLTELogo.png" alt="AdminLTE Logo" class="brand-image img-circle elevation-3"
					style="opacity: .8">
					<span class="brand-text font-weight-light text-white">ACES Chile</span>
				</router-link>
				
				<a class="nav-link" data-widget="pushmenu" href="#"><i class="fas fa-bars"></i></a>

				<div class="collapse navbar-collapse order-3" id="navbarCollapse">
					<!-- Left navbar links -->
					<ul class="navbar-nav">
						<li class="nav-item" v-if="role.id == 1">
							<router-link to="/test" class="nav-link">Test</router-link>
						</li>
						<li class="nav-item dropdown" v-if="role.id == -1">
							<a id="dropdownSubMenu1" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="nav-link dropdown-toggle">Dropdown</a>
							<ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow">
								<li><a href="#" class="dropdown-item">Some action </a></li>
								<li><a href="#" class="dropdown-item">Some other action</a></li>

								<li class="dropdown-divider"></li>

								<!-- Level two dropdown-->
								<li class="dropdown-submenu dropdown-hover">
									<a id="dropdownSubMenu2" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-item dropdown-toggle">Hover for action</a>
									<ul aria-labelledby="dropdownSubMenu2" class="dropdown-menu border-0 shadow">
										<li>
											<a tabindex="-1" href="#" class="dropdown-item">level 2</a>
										</li>

										<!-- Level three dropdown-->
										<li class="dropdown-submenu">
											<a id="dropdownSubMenu3" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-item dropdown-toggle">level 2</a>
											<ul aria-labelledby="dropdownSubMenu3" class="dropdown-menu border-0 shadow">
												<li><a href="#" class="dropdown-item">3rd level</a></li>
												<li><a href="#" class="dropdown-item">3rd level</a></li>
											</ul>
										</li>
										<!-- End Level three -->

										<li><a href="#" class="dropdown-item">level 2</a></li>
										<li><a href="#" class="dropdown-item">level 2</a></li>
									</ul>
								</li>
								<!-- End Level two -->
							</ul>
						</li>
					</ul>

					<!-- SEARCH FORM -->
					<form class="form-inline ml-0 ml-md-3">
						<div class="input-group input-group-sm" v-if="role.id == -1">
							<input class="form-control form-control-navbar" type="search" placeholder="Search" aria-label="Search">
							<div class="input-group-append">
								<button class="btn btn-navbar" type="submit">
									<i class="fas fa-search"></i>
								</button>
							</div>
						</div>
					</form>
				</div>

				<!-- Right navbar links -->
				<ul class="order-1 order-md-3 navbar-nav navbar-no-expand ml-auto">
					<!-- Messages Dropdown Menu -->
					<li class="nav-item dropdown" v-if="role.id==-1">
						<a class="nav-link" data-toggle="dropdown" href="#">
							<i class="fas fa-comments"></i>
							<span class="badge badge-danger navbar-badge">3</span>
						</a>
						<div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
							<a href="#" class="dropdown-item">
								<!-- Message Start -->
								<div class="media">
									<img src="/adminlte/dist/img/user1-128x128.jpg" alt="User Avatar" class="img-size-50 mr-3 img-circle">
									<div class="media-body">
										<h3 class="dropdown-item-title">
											Brad Diesel
											<span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>
										</h3>
										<p class="text-sm">Call me whenever you can...</p>
										<p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
									</div>
								</div>
								<!-- Message End -->
							</a>
							<div class="dropdown-divider"></div>
							<a href="#" class="dropdown-item">
								<!-- Message Start -->
								<div class="media">
									<img src="node_modules/admin-lte/dist/img/user8-128x128.jpg" alt="User Avatar" class="img-size-50 img-circle mr-3">
									<div class="media-body">
										<h3 class="dropdown-item-title">
											John Pierce
											<span class="float-right text-sm text-muted"><i class="fas fa-star"></i></span>
										</h3>
										<p class="text-sm">I got your message bro</p>
										<p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
									</div>
								</div>
								<!-- Message End -->
							</a>
							<div class="dropdown-divider"></div>
							<a href="#" class="dropdown-item">
								<!-- Message Start -->
								<div class="media">
									<img src="node_modules/admin-lte/dist/img/user3-128x128.jpg" alt="User Avatar" class="img-size-50 img-circle mr-3">
									<div class="media-body">
										<h3 class="dropdown-item-title">
											Nora Silvester
											<span class="float-right text-sm text-warning"><i class="fas fa-star"></i></span>
										</h3>
										<p class="text-sm">The subject goes here</p>
										<p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
									</div>
								</div>
								<!-- Message End -->
							</a>
							<div class="dropdown-divider"></div>
							<router-link to="/chat" class="dropdown-item dropdown-footer">Ver Mensajes</router-link>
						</div>
					</li>
					<!-- Notifications Dropdown Menu -->
					<li class="nav-item dropdown" v-if="role.id== -1">
						<a class="nav-link" data-toggle="dropdown" href="#">
							<i class="far fa-bell"></i>
							<span class="badge badge-warning navbar-badge">15</span>
						</a>
						<div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
							<span class="dropdown-header">15 Notifications</span>
							<div class="dropdown-divider"></div>
							<a href="#" class="dropdown-item">
								<i class="fas fa-envelope mr-2"></i> 4 new messages
								<span class="float-right text-muted text-sm">3 mins</span>
							</a>
							<div class="dropdown-divider"></div>
							<a href="#" class="dropdown-item">
								<i class="fas fa-users mr-2"></i> 8 friend requests
								<span class="float-right text-muted text-sm">12 hours</span>
							</a>
							<div class="dropdown-divider"></div>
							<a href="#" class="dropdown-item">
								<i class="fas fa-file mr-2"></i> 3 new reports
								<span class="float-right text-muted text-sm">2 days</span>
							</a>
							<div class="dropdown-divider"></div>
							<a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>
						</div>
					</li>
					<li class="nav-item" v-if="navItemControlSidebarVisible">
						<a class="nav-link" data-widget="control-sidebar" data-slide="true" href="#">
							<i class="fas fa-th-large"></i>
						</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="#" title="Configuración general">
							<i class="fas fa-cog" data-toggle="modal" data-target="#configGeneralModal" ref="configGeneralModal"></i>
						</a>
					</li>
					<!-- Logout -->
					<li class="nav-item dropdown">
						<router-link class="nav-link" to="/logout" title="Salir">
							<i class="fas fa-sign-in-alt"></i>
						</router-link>
					</li>
				</ul>
			</div>
		</nav>
		<aside class="main-sidebar sidebar-dark-primary elevation-4">
			<!-- Brand Logo -->
			<div class="brand-link">
				<img src="../node_modules/admin-lte/dist/img/AdminLTELogo.png"
				alt="AdminLTE Logo"
				class="brand-image img-circle elevation-3"
				style="opacity: .8">
				<span class="brand-text font-weight-light">ACES Chile</span>
				<i class="right fas fa-angle-left float-right" data-widget="pushmenu" ></i>
			</div>

			<!-- Sidebar -->
			<div class="sidebar">
				<!-- Sidebar user (optional) -->
				<div class="user-panel mt-3 pb-3 mb-3 d-flex" v-if="getUser.name !== undefined">
					<div class="image">
						<img :src="this.getUrlImagen + 'perfil/' + getUser.img" class="img-circle elevation-2" alt="User Image">
					</div>
					<div class="info">
						<router-link to="/profile" class="d-block" v-if="role.id == 1">
							{{ getUser.name }}
						</router-link>
						<a class="d-block" v-else>
							{{ getUser.name }}
						</a>
						<small class="text-light">{{ role.name }}</small>
					</div>
				</div>

				<!-- Sidebar Menu -->
				<nav class="mt-2">
					<ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
					<!-- Add icons to the links using the .nav-icon class
						with font-awesome or any other icon font library -->

						<li class="nav-item" v-for="(item, index) in menuLevel1" :key="index"
							:class="item.to === null || item.to === '' ? (menuIdSalected == item.id) ? 'has-treeview menu-open' : 'has-treeview' : ''">
							<router-link v-if="item.to !== null && item.to !== ''" :to="item.to" class="nav-link">
								<i class="nav-icon" :class="item.class"></i>
								<p>
									{{ item.name }}
								</p>
							</router-link>
							<a href="#" class="nav-link pointer" v-if="item.to == null || item.to == ''" @click="(menuIdSalected == item.id) ? menuIdSalected = 0 : menuIdSalected = item.id">
								<i class="nav-icon" :class="item.class"></i>
								<p>
									{{ item.name }}
									<i class="right fas fa-angle-left"></i>
								</p>
							</a>
							<ul class="nav nav-treeview" style="margin-left: 15px;" v-if="item.to == null || item.to == ''">
								<li class="nav-item" v-for="(item2, index2) in menuLevel2" :key="index2" v-if="item.id == item2.id_parent">
									<router-link class="nav-link" :to="item2.to">
										<i class="nav-icon" :class="item2.class"></i>
										<p>{{ item2.name }}</p>
									</router-link>
								</li>
							</ul>
						</li>
						<div v-if="1==2 && role.id == 1">
						<li class="nav-item has-treeview">
							<a href="#" class="nav-link">
								<i class="nav-icon fas fa-tachometer-alt"></i>
								<p>
									Dashboard
									<i class="right fas fa-angle-left"></i>
								</p>
							</a>
							<ul class="nav nav-treeview">
								<li class="nav-item">
									<router-link to="/dashboard1" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Dashboard v1</p>
									</router-link>
								</li>
								<li class="nav-item">
									<a href="../../index2.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Dashboard v2</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../../index3.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Dashboard v3</p>
									</a>
								</li>
							</ul>
						</li>
						<li class="nav-item">
							<a href="../widgets.html" class="nav-link">
								<i class="nav-icon fas fa-th"></i>
								<p>
									Widgets
									<span class="right badge badge-danger">New</span>
								</p>
							</a>
						</li>
						<li class="nav-item has-treeview menu-open">
							<a href="#" class="nav-link active">
								<i class="nav-icon fas fa-copy"></i>
								<p>
									Layout Options
									<i class="fas fa-angle-left right"></i>
									<span class="badge badge-info right">6</span>
								</p>
							</a>
							<ul class="nav nav-treeview">
								<li class="nav-item">
									<a href="../layout/top-nav.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Top Navigation</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../layout/top-nav-sidebar.html" class="nav-link active">
										<i class="far fa-circle nav-icon"></i>
										<p>Top Navigation + Sidebar</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../layout/boxed.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Boxed</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../layout/fixed-sidebar.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Fixed Sidebar</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../layout/fixed-topnav.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Fixed Navbar</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../layout/fixed-footer.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Fixed Footer</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../layout/collapsed-sidebar.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Collapsed Sidebar</p>
									</a>
								</li>
							</ul>
						</li>
						<li class="nav-item has-treeview">
							<a href="#" class="nav-link">
								<i class="nav-icon fas fa-chart-pie"></i>
								<p>
									Charts
									<i class="right fas fa-angle-left"></i>
								</p>
							</a>
							<ul class="nav nav-treeview">
								<li class="nav-item">
									<a href="../charts/chartjs.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>ChartJS</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../charts/flot.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Flot</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../charts/inline.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Inline</p>
									</a>
								</li>
							</ul>
						</li>
						<li class="nav-item has-treeview">
							<a href="#" class="nav-link">
								<i class="nav-icon fas fa-tree"></i>
								<p>
									UI Elements
									<i class="fas fa-angle-left right"></i>
								</p>
							</a>
							<ul class="nav nav-treeview">
								<li class="nav-item">
									<a href="../UI/general.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>General</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../UI/icons.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Icons</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../UI/buttons.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Buttons</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../UI/sliders.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Sliders</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../UI/modals.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Modals & Alerts</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../UI/navbar.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Navbar & Tabs</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../UI/timeline.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Timeline</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../UI/ribbons.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Ribbons</p>
									</a>
								</li>
							</ul>
						</li>
						<li class="nav-item has-treeview">
							<a href="#" class="nav-link">
								<i class="nav-icon fas fa-edit"></i>
								<p>
									Forms
									<i class="fas fa-angle-left right"></i>
								</p>
							</a>
							<ul class="nav nav-treeview">
								<li class="nav-item">
									<a href="../forms/general.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>General Elements</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../forms/advanced.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Advanced Elements</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../forms/editors.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Editors</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../forms/validation.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Validation</p>
									</a>
								</li>
							</ul>
						</li>
						<li class="nav-item has-treeview">
							<a href="#" class="nav-link">
								<i class="nav-icon fas fa-table"></i>
								<p>
									Tables
									<i class="fas fa-angle-left right"></i>
								</p>
							</a>
							<ul class="nav nav-treeview">
								<li class="nav-item">
									<a href="../tables/simple.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Simple Tables</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../tables/data.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>DataTables</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../tables/jsgrid.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>jsGrid</p>
									</a>
								</li>
							</ul>
						</li>
						<li class="nav-header">EXAMPLES</li>
						<li class="nav-item">
							<a href="../calendar.html" class="nav-link">
								<i class="nav-icon far fa-calendar-alt"></i>
								<p>
									Calendar
									<span class="badge badge-info right">2</span>
								</p>
							</a>
						</li>
						<li class="nav-item">
							<a href="../gallery.html" class="nav-link">
								<i class="nav-icon far fa-image"></i>
								<p>
									Gallery
								</p>
							</a>
						</li>
						<li class="nav-item has-treeview">
							<a href="#" class="nav-link">
								<i class="nav-icon far fa-envelope"></i>
								<p>
									Mailbox
									<i class="fas fa-angle-left right"></i>
								</p>
							</a>
							<ul class="nav nav-treeview">
								<li class="nav-item">
									<a href="../mailbox/mailbox.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Inbox</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../mailbox/compose.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Compose</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../mailbox/read-mail.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Read</p>
									</a>
								</li>
							</ul>
						</li>
						<li class="nav-item has-treeview">
							<a href="#" class="nav-link">
								<i class="nav-icon fas fa-book"></i>
								<p>
									Pages
									<i class="fas fa-angle-left right"></i>
								</p>
							</a>
							<ul class="nav nav-treeview">
								<li class="nav-item">
									<a href="../examples/invoice.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Invoice</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/profile.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Profile</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/e_commerce.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>E-commerce</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/projects.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Projects</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/project_add.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Project Add</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/project_edit.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Project Edit</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/project_detail.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Project Detail</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/contacts.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Contacts</p>
									</a>
								</li>
							</ul>
						</li>
						<li class="nav-item has-treeview menu-open">
							<a href="#" class="nav-link">
								<i class="nav-icon far fa-plus-square"></i>
								<p>
									Extras
									<i class="fas fa-angle-left right"></i>
								</p>
							</a>
							<ul class="nav nav-treeview">
								<li class="nav-item">
									<a href="../examples/login.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Login</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/register.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Register</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/forgot-password.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Forgot Password</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/recover-password.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Recover Password</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/lockscreen.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Lockscreen</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/legacy-user-menu.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Legacy User Menu</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/language-menu.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Language Menu</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/404.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Error 404</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/500.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Error 500</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/pace.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Pace</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../examples/blank.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Blank Page</p>
									</a>
								</li>
								<li class="nav-item">
									<a href="../../starter.html" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Starter Page</p>
									</a>
								</li>
							</ul>
						</li>
						<li class="nav-header">MISCELLANEOUS</li>
						<li class="nav-item">
							<a href="https://adminlte.io/docs/3.0" class="nav-link">
								<i class="nav-icon fas fa-file"></i>
								<p>Documentation</p>
							</a>
						</li>
						<li class="nav-header">MULTI LEVEL EXAMPLE</li>
						<li class="nav-item">
							<a href="#" class="nav-link">
								<i class="fas fa-circle nav-icon"></i>
								<p>Level 1</p>
							</a>
						</li>
						<li class="nav-item has-treeview">
							<a href="#" class="nav-link">
								<i class="nav-icon fas fa-circle"></i>
								<p>
									Level 1
									<i class="right fas fa-angle-left"></i>
								</p>
							</a>
							<ul class="nav nav-treeview">
								<li class="nav-item">
									<a href="#" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Level 2</p>
									</a>
								</li>
								<li class="nav-item has-treeview">
									<a href="#" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>
											Level 2
											<i class="right fas fa-angle-left"></i>
										</p>
									</a>
									<ul class="nav nav-treeview">
										<li class="nav-item">
											<a href="#" class="nav-link">
												<i class="far fa-dot-circle nav-icon"></i>
												<p>Level 3</p>
											</a>
										</li>
										<li class="nav-item">
											<a href="#" class="nav-link">
												<i class="far fa-dot-circle nav-icon"></i>
												<p>Level 3</p>
											</a>
										</li>
										<li class="nav-item">
											<a href="#" class="nav-link">
												<i class="far fa-dot-circle nav-icon"></i>
												<p>Level 3</p>
											</a>
										</li>
									</ul>
								</li>
								<li class="nav-item">
									<a href="#" class="nav-link">
										<i class="far fa-circle nav-icon"></i>
										<p>Level 2</p>
									</a>
								</li>
							</ul>
						</li>
						<li class="nav-item">
							<a href="#" class="nav-link">
								<i class="fas fa-circle nav-icon"></i>
								<p>Level 1</p>
							</a>
						</li>
						<li class="nav-header">LABELS</li>
						<li class="nav-item">
							<a href="#" class="nav-link">
								<i class="nav-icon far fa-circle text-danger"></i>
								<p class="text">Important</p>
							</a>
						</li>
						<li class="nav-item">
							<a href="#" class="nav-link">
								<i class="nav-icon far fa-circle text-warning"></i>
								<p>Warning</p>
							</a>
						</li>
						<li class="nav-item">
							<a href="#" class="nav-link">
								<i class="nav-icon far fa-circle text-info"></i>
								<p>Informational</p>
							</a>
						</li>
					</div>
					</ul>
				</nav>
				<!-- /.sidebar-menu -->
			</div>
			<!-- /.sidebar -->
		</aside>
		<div class="content-wrapper">
			<!-- Content Header (Page header) -->
			<div class="content-header">
				<div :class="container">
					<div class="row mb-2">
						<div class="col-sm-6">
							<h4 class="m-0 text-dark"> {{ headerModule.titleModule }} <small>{{ headerModule.subTitleModule }}</small></h4>
						</div><!-- /.col -->
						<div class="col-sm-6">
							<i v-if="headerModule.id > 1" @click="changeFavorite(headerModule.id, headerModule.favorite)" class="float-sm-right pointer" :class="(headerModule.favorite) ? 'fas fa-star text-primary' : 'far fa-star text-mute' " :title="(headerModule.favorite) ? 'Quitar de favoritos' : 'Agregar a favoritos'"></i>
							<!--<ol class="breadcrumb float-sm-right">
								<li class="breadcrumb-item"><a href="#">Home</a></li>
								<li class="breadcrumb-item"><a href="#">Layout</a></li>
								<li class="breadcrumb-item active">Top Navigation</li>
							</ol> -->
						</div><!-- /.col -->
					</div><!-- /.row -->
				</div><!-- /.container-fluid -->
			</div>
			<div class="content">
				<div :class="container">
					<router-view @btnShowLockScreen="btnShowLockScreen" @showLockScreen="showLockScreen" @hideLockScreen="hideLockScreen" @showConfigGeneral="showConfigGeneral" @emitSocketMsg="emitMessageGeneral"/>
				</div><!-- /.container-fluid -->
			</div>
		</div>
		<!-- Control Sidebar -->
		<aside class="control-sidebar control-sidebar-dark">
			<!-- Control sidebar content goes here -->
			<div class="p-3">
				<p class="text-white">Usuarios conectados</p>
				<ul style="font-size: 12px">
					<li v-for="(item, index) in listUsersConections" :key="index">
						<img :src="getUrlImagen + 'perfil/' + item.img" style="width:16px" class="rounded-circle"/>
						{{item.name}}
					</li>
				</ul>
			</div>
		</aside>
		<!-- /.control-sidebar -->

		<!-- Main Footer -->
		<footer class="main-footer">
			<!-- To the right -->
			<div class="float-right d-none d-sm-inline">
				<strong @click="clearConsole">iS</strong>ystem 4
			</div>
			<div class="float-right d-none d-sm-inline separator"></div>
			<img :src="'/img/' + getEnvironmentCurrent + '.png'" class="float-right d-none d-sm-inline img-footer" :title="apiBackend" @dblclick="changeEnvironment">
			<div class="float-right d-none d-sm-inline separator"></div>
			<img src="/img/socketioicon.png" class="float-right d-none d-sm-inline img-footer" :class="(!statusConectionPHP) ? 'img-opacity025 img-danger' : 'img-success'" title="SocketIO">
			<!-- Default to the left -->
			<strong>Copyright &copy; 2022 <a href="https://tionline.cl">TiOnline.cl</a>.</strong> All rights reserved.
		</footer>

		<lock-screen ref="lockScreen" @hideLockScreen="hideLockScreen"></lock-screen>

		<!-- Modal Configuración general-->
		<div class="modal fade" id="configGeneralModal" tabindex="-1" aria-labelledby="configGeneralModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title" id="configGeneralModalLabel">Configuración General</h6>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<config-general-component></config-general-component>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
				</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import socketPHP from '@/mixins/socketPHP.js'
import config from '@/config'
import LockScreen from '@/components/LockScreen.vue'
import ConfigGeneralComponent from '@/components/ConfigGeneralComponent.vue'

import { mapActions, mapMutations } from 'vuex';

export default {
	name: 'AdminLTE',
	mixins: [axiosAction, errors, mixin, socketPHP],
	data() {
		return {
			loading: false,
			methods: {
				getShowMenu: 'menu/',
				getRole: 'auth/getRole',
			},
			menu: [],
			listMenuUser: [],
			menuIdSalected: 0
		}
	},
	components: {
		'lock-screen': LockScreen,
		'config-general-component': ConfigGeneralComponent
	},
	computed: {
		menuLevel1() {
			return this.getMenu.filter((el) => el.level == 1)
		},
		menuLevel2() {
			return this.getMenu.filter((el) => el.level == 2)
		},
		navItemControlSidebarVisible() {
			if(this.role.id == 9)
				return false
			if(this.role.id == 10)
				return false
			return true
		}
	},
	methods: {
		addListMenuUser(newMenuUser) {
			this.listMenuUser.push(newMenuUser)
		},
		addMenuUser(menu_id) {
			this.axiosActionIS(this.apiBackend + this.methods.getShowMenu + 'menuUser/register', 'POST', 'addMenuUserResult', {'menu_id': menu_id})
		},
		addMenuUserResult(response) {
			this.addListMenuUser(response.data[0])
			this.setFavorite(1)
		},
		changeFavorite(menu_id, status) {
			if(status) {
				this.deleteMenuUser(menu_id)
			} else {
				this.addMenuUser(menu_id)
			}
		},
		deleteItemListMenuUser(id) {
			let index = this.listMenuUser.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			let menuUserDelete = this.listMenuUser.splice(index,1)
		},
		deleteMenuUser(menu_id) {
			this.axiosActionIS(this.apiBackend + this.methods.getShowMenu + menu_id + '/menuUser/delete' , 'DELETE', 'deleteMenuUserResult')
		},
		deleteMenuUserResult(response) {
			this.deleteItemListMenuUser(response.data)
			this.setFavorite(0)
		},
		emitMessageGeneral(request) {
			console.log(emitMessageGeneral)
		},
		initLayoutLocal() {
			this.checkConection()
			this.getMenuLeft()
			if(this.$router.history._startLocation == '/') {
				if(this.auth.role_id == 9)
					this.$router.push('/orders')
			}
		},
		iniConfigAuth() {
			this.setListeningConnection('USER')
			this.getRole()
		},
		receptionUser(data) {
			if(data.idUser == this.auth.id) {
				if(confirm('Se han logueado con tu cuenta en otro lado.\n¿Desea cerrar ese ingreso?')) {
					this.socketEmit([data.idConect + '_LOGOUT'], '')
				}
			}
		},
		resultAxiosLocal(action, response) {
			switch (action) {
				case 'addMenuUserResult': this.addMenuUserResult(response); break;
				case 'deleteMenuUserResult': this.deleteMenuUserResult(response); break;
				case 'resultGetRole': this.resultGetRole(response); break;
				default: console.log(action + ' no desarrollado!!!'); break;
			}
		},
		resultGetRole(response) {
			if(response.data.length == 1) {
				this.setRole(response.data[0])
			}
		},
		setListeningConnection(type) {
			switch(type) {
				case 'USER':
					//this.sockets.subscribe('NOTIFY_CONNECT_USER', (data) => { this.receptionUser(data) })
					this.sockets.subscribe('USER_' + this.auth.id , (data) => { console.log(data) })
					break;
				case 'CONNECTION':
					this.sockets.subscribe('CONNECTION_' + this.io , (data) => { console.log(data) })
					this.sockets.subscribe(this.io + '_LOGOUT', (data) => { alert("has algo") })
					break;
				default:
					break;
			}
		},
		showConfigGeneral() {
			this.$refs.configGeneralModal.click()
		},
		getRole() {
			this.axiosActionIS(this.apiBackend + this.methods.getRole, 'GET', 'resultGetRole')
		},
	},
	mounted () {
		this.initLayout()
		this.setSocketFacturacionCLConnect(config.URL_WEB_SOCKET_FACTURACIONCL)
		this.startConnectionSocketPHP()
	},
	sockets: {
        connect: function (sockets) {
        	this.setSocket(this.$socket)
        	this.setSocketioConnect(true)
			this.greet()
			this.setListeningConnection('CONNECTION')
		},
        customEmit: function (data) {
            console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
        },
        disconnect: function() {
        	this.setSocketioConnect(false)
        	this.setGreeted(false);
        }
	},
	socketFacturacionCL: {
		onopen: function (q) {
			console.log('yaaa')
		},
		onclose: function (q) {
			console.log('yaaa')
		},
		onmessage: function (q) {
			console.log('yaaa')
		},
	}
}	
</script>

<style lang="scss">
@import './assets/css/isystem4.scss';
</style>
